import pino from 'pino'

export const log = pino({
  level: process.env.LOG_LEVEL,
  formatters: {
    level: (label, number) => ({
      level: number,
      prefix: label,
    })
  }
})
